import { Helmet } from "react-helmet-async";

const SITE = "https://successio.ai";

interface PageHeadProps {
  title: string;
  description: string;
  path: string;
  noindex?: boolean;
}

const PageHead = ({ title, description, path, noindex }: PageHeadProps) => {
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {noindex && <meta name="robots" content="noindex, follow" />}
    </Helmet>
  );
};

export default PageHead;
